/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensFromJSON, FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokens';
import { FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSON, FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSON, } from './FxIdApplicationHandlersAuthAuthenticateWithExternalIdState';
import { FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsFromJSON, FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptions';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdResponse(value) {
    if (!('State' in value) || value['State'] === undefined)
        return false;
    if (!('Hint' in value) || value['Hint'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'State': FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateFromJSON(json['State']),
        'Tokens': json['Tokens'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensFromJSON(json['Tokens']),
        'Hint': json['Hint'],
        'Email': json['Email'] == null ? undefined : json['Email'],
        'TransferOptions': json['TransferOptions'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsFromJSON(json['TransferOptions']),
    };
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'State': FxIdApplicationHandlersAuthAuthenticateWithExternalIdStateToJSON(value['State']),
        'Tokens': FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensToJSON(value['Tokens']),
        'Hint': value['Hint'],
        'Email': value['Email'],
        'TransferOptions': FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTransferOptionsToJSON(value['TransferOptions']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse.js.map